export const linkToSupport = 'https://support.atlassian.com/contact/#/';

export const feedbackWidgetData = {
	entrypointId: 'f914e972-dc30-4b2c-ab56-fbd0964085c0',
};
